module.exports = __webpack_public_path__ + "static/media/click_collect.0bd07df0.png";